import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import DataTable from "../../../containers/organism/DataTable";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import InformationText from "../../../components/molecules/InformationText";
import { connect } from "react-redux";
import { DeleteDrafPinjaman } from "../../../redux/actions/DrafPinjaman";
import Loan from "../../../redux/actions/Loan";
import Loading from "../../../components/molecules/Loading";

import curencyFormat from "../../../utils/helpers/curencyFormat";
import dateFormatIndo from "../../../utils/helpers/dateFormatIndo";
import Button from "../../../components/atoms/Button";
import ModalInformation from "../../organism/ModalInformation";

class Notifikasi extends Component {
	constructor(props) {
		super(props);
		this.state = {
			confirmDelete: false,
			coloumnDataTable: [
				{ data: "loanCode", width: "140", title: "Kode Pinjaman" },
				{ data: "nameProductMapping", width: "120", title: "Tipe Pinjaman" },
				/*{ data: "collateralType",	width : "20%", title: "Tipe Jaminan" },*/
				{ data: "loanAmount", width: "100", title: "Nilai Pinjaman" },
				/*{ data: "collateralDetail",		width : "15%", title: "Nilai Jaminan" },*/
				{ data: "updatedAt", width: "120", className: "dt-center", title: "Terakhir Diperbaharui" },
				{ data: "loanPurpose", width: "150", title: "Tujuan Pinjaman" },
				{ data: "loanCode", width: "150", className: "dt-center", title: "" },
			],
			coloumnDefs: [
				{
					targets: [0, 1, 4],
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span> {cellData || "-"} </span>, td);
					},
				},
				{
					targets: 2,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span> Rp {cellData ? curencyFormat(cellData) : "-"} </span>, td);
					},
				},
				/*{
					targets: 4,
					createdCell: (td, cellData, rowData, row, col) => { 
						ReactDOM.render( <span> Rp {cellData.invoiceAmount ? curencyFormat(cellData.invoiceAmount) : "-"} </span>, td );
					}
				},*/
				{
					targets: 3,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span> {cellData ? dateFormatIndo(cellData, "long") : "-"} </span>, td);
					},
				},
				{
					targets: 5,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(
							<div className="d-flex">
								<Button
									onClick={() => {
										this.handleDetail(cellData);
									}}
									title="Lihat"
									color="blue"
									width="small"
									className="mr-3"
								/>
								<Button
									onClick={() => {
										this.handleDelete(cellData);
									}}
									title="Lihat"
									color="red"
									width="smallAuto"
								>
									<i className="fas fa-trash-alt"></i>
								</Button>
							</div>,
							td
						);
					},
				},
			],
		};
	}

	handleDetail = (id = null) => {
		let url;
		id === null ? (url = `draf-pinjaman/add`) : (url = `draf-pinjaman/edit/${id}`);

		this.props.history.push(url);
	};

	handleDelete = (confirm) => {
		const { RefreshToken, DeleteLoan } = this.props;
		if (confirm) {
			this.setState({
				confirmDelete: confirm,
			});
		} else {
			RefreshToken((ClientID) => {
				DeleteLoan(ClientID, this.state.confirmDelete);
				this.setState({
					confirmDelete: false,
				});
			});
		}
	};

	componentDidMount = () => {
		const { setTitlePage, ClientID, GetListLoan } = this.props;

		if (ClientID) {
			GetListLoan(ClientID);
		}
		setTitlePage({
			title: "Draf Pinjaman",
			breadcrumb: [
				{ name: "Beranda", url: "/dashboard", status: false },
				{ name: "Draf Pinjaman", url: "/#", status: true },
			],
		});

		console.log("Mount Draft Pinjaman");
	};

	render() {
		const { loan } = this.props;
		const modalProps = {
			show: this.state.confirmDelete,
			title: "Hapus Draf Pinjaman",
			content: `Draf Pinjaman dengan kode ${this.state.confirmDelete} akan dihapus. Apakah Anda yakin?`,
			icon: "/img/icon/Warning-Big.png",
			actYes: {
				title: "Ya, Hapus",
				action: () => {
					this.handleDelete(false);
				},
			},
			actNo: {
				title: "BATAL",
				action: () => {
					this.setState({ confirmDelete: false });
				},
			},
			actClose: () => {
				this.setState({ confirmDelete: false });
			},
		};

		return loan.loading ? (
			<Loading />
		) : (
			<Fragment>
				<div className="d-flex justify-content-end mb-4">
					<Button title="Tambah Pinjaman" onClick={() => this.handleDetail()} color="green" width="big" />
				</div>

				<DataTable data={loan.list} fixedWidthColoumn={true} idTable="drafPinjaman" coloumn={this.state.coloumnDataTable} coloumnDefs={this.state.coloumnDefs} />

				{loan.errorMessage && <InformationText className="mt-3" value={loan.errorMessage} type="error" />}
				<ModalInformation {...modalProps} />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		loan: state.loanState,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		GetListLoan: (ClientID) => {
			dispatch(Loan(ClientID, ["DF1"]));
		},
		DeleteLoan: (ClientID, loanID) => {
			dispatch(DeleteDrafPinjaman(ClientID, loanID));
		},
	};
};

export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(Notifikasi));
